/**
  メイントップページ
*/
<template>
  <v-ons-page>
    <ms-toolbar mode="order"></ms-toolbar>
    <div class="content">
      <div class="fv">
        <div class="thumbnail">
          <div class="no-item-img" v-if="GoodsInfo.img_url==''" alt=""></div>
          <img v-if="GoodsInfo.img_url!=''" :src="GoodsInfo.img_url" alt="">
        </div>
        <h2 class="goods_label">{{GoodsInfo.GoodsName}} <br><small>{{GoodsInfo.PriceN}}円（税込 {{GoodsInfo.PriceK}}円）</small></h2>
        <h4 style="color:red" v-if="Number(GoodsInfo.OrderZan)>0 && Number(GoodsInfo.OrderZan)<10">{{localizeLabel("Order", "label_zan")}}：{{GoodsInfo.OrderZan}}</h4>
      </div>
      
      <div class="input_container">
        <div class="input_form" v-if="requestExist==false">
          <v-ons-button modifier="outline" style="" :disabled="cartItem.count==1" @click="checkCount(cartItem.count-1)">
            <img src="../assets/img/ico_minus.svg" alt="">
          </v-ons-button>
          <input type="phone" placeholder="" readonly v-model="cartItem.count">
          <v-ons-button modifier="outline" style="" @click="checkCount(cartItem.count+1)" :disabled="CheckLimitCount(cartItem, GoodsInfo.OrderZan,true)<=0">
            <img src="../assets/img/ico_plus.svg" alt="">
          </v-ons-button>
        </div>
        
        <div class="request_block"  v-if="requestExist">
          <div class="request_item" :class="{active: item.request_name!=''}" v-for="(item, index) in request_form" :key="index">
            <p class="resuest_name">
              {{item.request_name}}
            </p>
            <div class="request_count" style="padding:3px 0">
              <v-ons-button modifier="outline" style="" :disabled="item.request_count==0" @click="CheckCartItemRequestCount({parent:cartItem, req_parent: request_form, item:item, count:item.request_count-1})">
                <img src="../assets/img/ico_minus.svg" alt="">
              </v-ons-button>
              <input type="phone" placeholder="" readonly v-model="item.request_count">
              <v-ons-button modifier="outline" style="" :disabled="CheckRequestLimitCount(request_form, GoodsInfo,true)<=0" @click="CheckCartItemRequestCount({parent:cartItem, req_parent: request_form, item:item, count:item.request_count+1})">
                <img src="../assets/img/ico_plus.svg" alt="">
              </v-ons-button>
            </div>
          </div>
          <hr>
          <div class="total">
              <p class="total_label">{{localizeLabel("Order", "label_total")}}：</p>
              <p class="total_count">{{cartItem.count}}</p>
          </div>
          
        </div>
         <!--構成品-->
        <div v-if="GoodsInfo.ConfigCount>0">
          <div v-for="(orderCateList, index) in orderCategoryList" :key="index">
            <div class="child_block" v-for="(config) in orderCateList.configList" :key="config.category_name">
              <hr>
              <div v-if="currentLangCode=='ja'">
                <p v-if="config.select_mode!=1" class="topping_text"><strong class="order_config_title">{{index+1}}品目</strong>の{{config.category_name}} を選んでください <span v-if="config.select_mode==0">（任意選択）</span></p>
                <p v-if="config.select_mode==1 && config.last_count>0" class="topping_text">{{config.category_name}} をあと{{ config.last_count }}つ選んでください</p>
              </div>
              <div v-if="currentLangCode=='en'">
                <p v-if="config.select_mode!=1" class="topping_text">Please select {{config.category_name}} for {{index+1}} item</p>
                <p v-if="config.select_mode==1 && config.last_count>0" class="topping_text">Please select {{ config.last_count }} more {{config.category_name}}</p>
              </div>
              <div v-if="currentLangCode=='ch'">
                <p v-if="config.select_mode!=1" class="topping_text">请选择{{index+1}}个{{config.category_name}} </p>
                <p v-if="config.select_mode==1 && config.last_count>0" class="topping_text">请再选择 {{ config.last_count }}个 {{config.category_name}}</p>
              </div>
              <div class="child_item" :class="{selected:item.count>0}" v-for="(item) in config.category_item" :key="item.code" @click="checkConfigSelected(config,item)">
                <div class="child_name">
                  <div class="selected_caption" v-if="config.limit_count==1 && item.count>0">
                    <v-ons-icon icon="fa-check-circle"></v-ons-icon>
                  </div>
                  {{item.name}}
                </div>
                <p class="child_price" v-if="">
                  ¥{{item.price}}
                </p>
                
                <div class="child_count" style="padding:3px 0" v-if="config.limit_count!=1">
                  <v-ons-button modifier="outline" style="" @click="checkChildCount(config, item, item.count-1)">
                    <img src="../assets/img/ico_minus.svg" alt="">
                  </v-ons-button>
                  <input type="phone" placeholder="" readonly v-model="item.count">
                  <v-ons-button modifier="outline" style="" @click="checkChildCount(config, item, item.count+1)" :disabled="item.add_disabled">
                    <img src="../assets/img/ico_plus.svg" alt="">
                  </v-ons-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr>
        <div class="total">
            <p class="total_label">{{localizeLabel("Order", "label_total")}}：</p>
            <p class="total_count">{{cartItem.count}}</p>
        </div>
        
        <v-ons-popover cancelable
          :visible.sync="popoverVisible"
          :target="popoverTarget"
          direction="up"
          cover-target="false"
        >
          <p style="text-align: center" v-html="popoverMessage"></p>
        </v-ons-popover>
        <div class="bottom_toolbar">
            <v-ons-button modifier="large" class="btn-add-cart" style="margin: 6px 0" @click="addCart($event)" :disabled="isNotOrderable">{{localizeLabel("Order", "label_add_cart")}}</v-ons-button>
        </div>
        
      </div>
    </div>
  </v-ons-page>
</template>

<script>
import Tabbar from "../components/msTabbar";
import Toolbar from "../components/msToolbar";
//import WaitingIcon from "../components/WaitingIcon";
import { mapGetters, mapActions } from "vuex";
//import moment from "moment";
//import "moment/locale/ja";

export default {
  name: "home",
  data() {
    return {
      GoodsInfo:null,
      popoverVisible:false,
      popoverTarget:null,
      popoverMessage:'',
      requestExist:false,
      childItemExist:false,
      isDblBack:false,
      request_form:[
        { request_name:'', request_count:0 },
        { request_name:'', request_count:0 },
        { request_name:'', request_count:0 },
        { request_name:'', request_count:0 },
        { request_name:'', request_count:0 },
        { request_name:'', request_count:0 },
        { request_name:'', request_count:0 },
        { request_name:'', request_count:0 },
      ],
      orderCategoryList: [], //構成品数×注文数のリスト
      //configList: [], //オーダー用の構成品リスト
      cartItem: [],
      configExist: false,
    }
  },
  created: function() {
   
    this.GoodsInfo= this.$attrs.propData.item_info
    this.isDblBack= this.$attrs.propData.back_flag

    var init_count=0
    //提供方法の初期化
    this.request_form[0].request_name=this.GoodsInfo.Request1
    this.request_form[1].request_name=this.GoodsInfo.Request2
    this.request_form[2].request_name=this.GoodsInfo.Request3
    this.request_form[3].request_name=this.GoodsInfo.Request4
    this.request_form[4].request_name=this.GoodsInfo.Request5
    this.request_form[5].request_name=this.GoodsInfo.Request6
    this.request_form[6].request_name=this.GoodsInfo.Request7
    this.request_form[7].request_name=this.GoodsInfo.Request8
    
    if(this.GoodsInfo.Request1 || this.GoodsInfo.Request2 || this.GoodsInfo.Request3 || this.GoodsInfo.Request4 ||
       this.GoodsInfo.Request5 || this.GoodsInfo.Request6 || this.GoodsInfo.Request7 || this.GoodsInfo.Request8){
         this.requestExist=true
    }
    
    this.initOrderCategoryList(1) //デフォルト１で構成品リストを初期化
    
    //提供方法ありの場合は初期値０
    if(this.requestExist){
      init_count=0
    }else{
      
      init_count=1
    }


    this.cartItem={
      submenu_code: this.CurrentSubmenu==null?'':this.CurrentSubmenu.Goods,
      item_info: this.GoodsInfo,
      request:   this.request_form,
      category:  [],
      count:     init_count,
    }
  },
  computed: {
    ...mapGetters([
      //'GoodsInfo',
      "localizeLabel",
      'currentLangCode',
      'CheckLimitCount',
      'CheckRequestLimitCount',
      'CheckCategoryLimitCount',
      'CurrentSubmenu',
      'CheckSubmenuSendLimit',
      'CheckSubmenuLockTime',
      'CartItemCount',
      ]),
      isNotOrderable(){
        if(this.cartItem.count==0){
          return true
        }
        var is_condition_clear=true
        var self=this
        this.orderCategoryList.forEach(function(orderCate){
          orderCate.configList.forEach(function(config){
            //lastcountが０でなければオーダ不可
            if(config.last_count>0 && config.select_mode==1){
              is_condition_clear=false
            }
            /*
            config.category_item.forEach(function(item){
                if(item.add_disabled==false){
                  //1つでもdisabledがあればオーダー不可
                  is_condition_clear=false
                }
            })
            */
          })
        })
        if(is_condition_clear==false){
          return true
        }
        
        return false
      },
  },
  methods: {
    ...mapActions([
      'popPage',
      'AddCartItem',
      'CheckCartItemCount',
      'CheckCartItemRequestCount',
      'CheckCartCategoryItemCount',
      'showErrorMessage',
      'showMessage',
    ]),
    //構成品がセレクトモードの時に行をクリックした際のイベント
    checkConfigSelected(config,item){
      if(config.limit_count==1){
        var count=0
        config.category_item.forEach(function(cate){
          if(cate.code==item.code && item.count==0){
              cate.add_disabled=false
              cate.count=1
              count++
          }else{
            cate.count=0
            cate.add_disabled=true
          }
        })
        config.last_count=config.limit_count-count
      }
    },
    //構成品の数を初期化
    initOrderCategoryList(order_count){
      this.orderCategoryList=[]

      //構成品の初期化
      for(var i=0; i<order_count; i++){
        var configList=[]
        if(this.GoodsInfo.ConfigCount>0){
          const self=this

          if(!Array.isArray(this.GoodsInfo.ConfigLists.ConfigList)){
            //構成品が1つの時　無理矢理配列にする
            var temp=JSON.parse(JSON.stringify(this.GoodsInfo.ConfigLists.ConfigList))//値渡しコピー
            this.GoodsInfo.ConfigLists.ConfigList=[]
            this.GoodsInfo.ConfigLists.ConfigList.push(temp)
          }

          this.GoodsInfo.ConfigLists.ConfigList.forEach(function(config){
            
            var categoryItems=[]
            if(!Array.isArray(config.CategolyItems.CategolyItem)){
              var temp=JSON.parse(JSON.stringify(config.CategolyItems.CategolyItem))//値渡しコピー
              config.CategolyItems.CategolyItem=[]
              config.CategolyItems.CategolyItem.push(temp)
            }
            config.CategolyItems.CategolyItem.forEach(function(item){
                categoryItems.push({ code: item.Goods, name: item.GoodsName, count: 0, price:item.PriceN, add_disabled: false})
            })

            //残り選択数の計算
            //config.last_count=Number(self.categoryItem.limit_count)
            configList.push({ 
              last_count: config.LimitCount,
              select_mode: config.SelectMode, 
              limit_count: config.LimitCount,
              category_name:config.CategolyName,
              category_item: categoryItems,
            })
          })
          

          this.orderCategoryList.push({ configList:configList})
        }

      }

    },
    checkRequestCount(item){
      this.CheckCartItemRequestCount(
        {
          parent: this.GoodsInfo, 
          item: item, 
          count: item.request_count
        }
      )      
    },
    checkChildCount(config, item, count){
      this.CheckCartCategoryItemCount(
        {
          parent: this.GoodsInfo, 
          cate_parent: this.cartItem, 
          items: config.category_item, 
          item: item, 
          count: count
        }
      )
      
      var order=0
      var self=this
      config.category_item.forEach(function(item){
        order=order+Number(item.count)
      })
      
      //残り選択数の計算
      config.last_count=Number(config.limit_count)-order
      
      this.checkTotalLimitCount()
    },
    checkTotalLimitCount(){
      var self=this
      //全商品でLimitを再チェックする
      this.orderCategoryList.forEach(function(orderCate){
          orderCate.configList.forEach(function(config){
            var order=0
      
            config.category_item.forEach(function(item){
              order=order+Number(item.count)
            })
            config.category_item.forEach(function(item){
                item.add_disabled= self.CheckCategoryLimitCount(config, order)
            })
          })
      })

      
    },
    checkCount(count){
      this.CheckCartItemCount(
        {
          parent: this.GoodsInfo, 
          item: this.cartItem, 
          count: count
        }
      )
      
      //構成品数量リセット
      this.initOrderCategoryList(count)
      /*
      this.categoryItem.last_count=(this.cartItem.count*Number(this.categoryItem.limit_count))
      this.categoryItem.category_item.forEach(function(item){
        item.count=0
      })
  */
    },

    checkReqCount(obj){
      
    },

    addCart(event){
     //残数チェック
     
     if(this.CheckLimitCount(this.cartItem, this.GoodsInfo.OrderZan,true)<0){
       this.popoverVisible=true
       this.popoverTarget=event
       this.popoverMessage="「"+this.GoodsInfo.GoodsName+"」<br>は残数オーバーのため、<br>これ以上追加できません"
     }else if(this.CheckSubmenuSendLimit(this.CurrentSubmenu, this.cartItem.count)<0){
       this.popoverVisible=true
       this.popoverTarget=event
       this.popoverMessage=this.CurrentSubmenu.GoodsName+"で<br>一度に注文できるのは<br>"+this.CurrentSubmenu.SendLimit+"品までです"
     }else if(this.CheckSubmenuLockTime(this.CurrentSubmenu)==false){
       this.popoverVisible=true
       this.popoverTarget=event
       this.popoverMessage=this.CurrentSubmenu.GoodsName+"の商品はもう少し時間をおいてからご注文ください"
     }else{
       //追加OK
       
      this.cartItem.category=this.orderCategoryList
      this.AddCartItem(this.cartItem)
        .then(()=>{
          this.popPage()
          if(this.isDblBack){
            //枝分かれからきた場合はさらに1つ戻る
            this.popPage()
          }
        }).catch(error=>{
          this.showErrorMessage(error)
        })
     }
    },  
  },
  
  components: {
    "ms-tabbar": Tabbar,
    "ms-toolbar": Toolbar,
    //"mc-waiting-icon": WaitingIcon
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" scoped>
@import "../assets/sass/base.scss";

.fv{
  min-height: 220px;
  position: relative;
  text-align: center;
  margin-bottom: 20px;
  padding-top: 20px;

  .thumbnail{
    //background: white;
    height: 200px;
    width: 260px;    
    margin: 0 auto 20px auto;

    overflow: hidden;
    position: relative;
    display:flex;
    justify-content: center;
    align-items: center;
    @media screen and (min-width: 768px) {
      height: 260px;
      width: 350px;
    }
    .no-item-img{
      width: 100%;
      height: 100%;
    }
    &> img{
      object-fit: cover;
      width: auto;
      height: 100%;
      //border-radius:10px;
    }
  }
}
.content{
  padding: 50px 10px 150px;
  //background-color: #111!important;
  background: $background-image-path!important;
  background-size: cover!important;
  color: $base-font-color;
}

.input_container{
  padding: 20px;
  
}
input{
  box-sizing: border-box;
    width: 50%;
    flex: 1;
    border: 1px solid #ccc;
    margin: 0 3px;
    border-radius: 5px;
    color: #222!important;
    text-align: center!important;
    font-size: 24px!important;
    max-width: 60px;
    height: 100%;
}
ons-button{
    min-width: 44px;
    font-size: 20px;
    text-align: center;
    border-color: $input-button-font-color;
    background-color: $input-button-color;
    display: flex;
    align-items: center;
    justify-content: center;  
  }
.input_form{
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  height: 43px;
  
}
.goods_label{
  font-size: 22px;
  font-weight: bold;
  small{
    font-weight: normal;
    display: inline-block;
    padding: 6px 12px;
    line-height: 1;
    background: $tab-base-bg-color;
    color: $header-font-color;
    border-radius: 5px;
    margin-left: 10px;
  }
}

.request_item{
  display: none;
  justify-content: space-between;
  align-content: center;
  height: 45px;
  &.active{
    display: flex;
  }
}
.child_item{
  display: flex;
  justify-content: space-between;
  align-content: center;
  padding: 0 10px;
}
.child_item.selected{
  background-color:$selected-row-color;
  color:$selected-font-color;
  border-radius: 5px;
  font-weight: bold;
}
.child_name{
  font-size: 12px;
  display:flex;
  align-items:center;
  justify-content: flex-start;
  text-align: left;
  flex:1;
  height: 44px;
  margin-right: 15px;
  @media screen and (min-width: 768px) {
    font-size: 14px;
  }
}
.child_price{
  font-size: 12px;
  display:flex;
  align-items:center;
  margin-right: 10px;
  @media screen and (min-width: 768px) {
    font-size: 14px;
  }
}
.selected_caption{
  display: inline-block;
  font-size:14px;
  text-align: right;
  line-height: 1;
  padding: 0;
  margin-right: 10px;
  @media screen and (min-width: 768px) {
    font-size: 18px;
  }
}
.request_count,
.child_count{
  min-width: 140px;
  display: flex;
  justify-content: space-between;
  align-content: center;
}
.child_count{
  height: 43px;
}
.total{
  display: flex;
  justify-content: center;
  align-content: center;
}
.total_label{
  font-size: 20px;
  font-weight: bold;
}
.total_count{
  font-size: 22px;
  font-weight: bold;
}

.topping_text{
  font-size: 14px;
  font-weight: bold;
  text-align: center;
}

.bottom_toolbar{
  background: $button-container-color;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  z-index: 100;
}
.order_config_title{
  //color: $primary-color;
  text-align: center;
  font-size: 18px;
}
.btn-add-cart{
  color: $input-button-font-color;
  background-color:$button-color;
}

.no-item-img{
    background: $no-item-image-path no-repeat;
    background-size: cover;
    background-position: center;
}

/****************************/
</style>



// WEBPACK FOOTER //
// src/pages/OrderPage.vue